import { render, staticRenderFns } from "./ApproveReq.vue?vue&type=template&id=6b1a072c&scoped=true&"
import script from "./ApproveReq.vue?vue&type=script&lang=js&"
export * from "./ApproveReq.vue?vue&type=script&lang=js&"
import style0 from "./ApproveReq.vue?vue&type=style&index=0&id=6b1a072c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1a072c",
  null
  
)

export default component.exports